import { Heading, InfoCardGridSection } from '@stereoagency/ui';
import flush from 'just-flush';
import useTranslation from 'next-translate/useTranslation';
import { jobAsProps } from '@/utils';
import { relatedJobsQuery } from './groupOrPlatformSubqueries';

type Props = {
  jobs?: (typeof relatedJobsQuery)[1];
};

export default function GroupOrPlatformJobs({ jobs }: Props) {
  const { t, lang } = useTranslation('research-group-or-platform');

  if (!jobs?.length) {
    return null;
  }

  return (
    <div>
      <div className="flex justify-between items-center flex-wrap mb-7 md:mb-9">
        <Heading id="jobs" as="h2" variant="h2">
          {t('sections.jobs.title')}
        </Heading>
      </div>

      <InfoCardGridSection
        variant="narrow"
        cards={flush(jobs.map((job) => jobAsProps(job, lang)))}
      />
    </div>
  );
}
